var React = require('react');

function Graphql (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.5,45.161L7,34.82V14.18L24.5,3.839L42,14.18V34.82L24.5,45.161z M9,33.68l15.5,9.159L40,33.68 V15.32L24.5,6.161L9,15.32V33.68z","key":0}),React.createElement("circle",{"cx":"24.5","cy":"5.5","r":"3.5","key":1}),React.createElement("circle",{"cx":"24.5","cy":"43.5","r":"3.5","key":2}),React.createElement("circle",{"cx":"8.5","cy":"33.5","r":"3.5","key":3}),React.createElement("circle",{"cx":"40.5","cy":"33.5","r":"3.5","key":4}),React.createElement("circle",{"cx":"8.5","cy":"15.5","r":"3.5","key":5}),React.createElement("circle",{"cx":"40.5","cy":"15.5","r":"3.5","key":6}),React.createElement("path",{"d":"M42.72,35H6.28L24.5,2.978L42.72,35z M9.72,33H39.28L24.5,7.022L9.72,33z","key":7})]);
}

Graphql.defaultProps = {"viewBox":"0 0 48 48","width":"48px","height":"48px"};

module.exports = Graphql;

Graphql.default = Graphql;
